export const BusinessLedgerTypes = {
    GET_BUSINESS_LEDGER:'GET_BUSINESS_LEDGER',
    GET_BUSINESS_LEDGER_TOTAL:'GET_BUSINESS_LEDGER_TOTAL',
}